import type { CustomerNote } from "@/types/customer-note";

/**
 * Mock customer notes data for demo mode
 */
export const mockCustomerNotes: Record<string, CustomerNote[]> = {
  "1": [
    {
      id: "note-1",
      customerId: "1",
      content: "Customer called to discuss payment plan for overdue invoices. Agreed to pay 50% by end of week and remaining balance within 30 days.",
      createdAt: "2024-01-15T14:30:00Z",
      createdBy: {
        id: "1",
        name: "John Smith",
      },
    },
    {
      id: "note-2",
      customerId: "1",
      content: "Sent payment reminder email for INV-001 and INV-002. Customer acknowledged receipt.",
      createdAt: "2024-01-12T09:15:00Z",
      createdBy: {
        id: "2",
        name: "Sarah Johnson",
      },
    },
    {
      id: "note-3",
      customerId: "1",
      content: "Customer requested copies of all outstanding invoices. Documents sent via email.",
      createdAt: "2024-01-10T16:45:00Z",
      createdBy: {
        id: "1",
        name: "John Smith",
      },
    },
    {
      id: "note-4",
      customerId: "1",
      content: "Initial credit review completed. Credit limit increased from $150,000 to $200,000 based on improved payment history.",
      createdAt: "2024-01-05T11:20:00Z",
      createdBy: {
        id: "3",
        name: "Mike Wilson",
      },
    },
  ],
  "2": [
    {
      id: "note-5",
      customerId: "2",
      content: "Customer has consistently paid on time. Excellent payment history over the past 12 months.",
      createdAt: "2024-01-14T10:00:00Z",
      createdBy: {
        id: "2",
        name: "Sarah Johnson",
      },
    },
    {
      id: "note-6",
      customerId: "2",
      content: "Discussed new payment terms. Customer requested Net 45 instead of Net 30. Approved based on strong payment record.",
      createdAt: "2024-01-08T13:30:00Z",
      createdBy: {
        id: "1",
        name: "John Smith",
      },
    },
  ],
  "3": [
    {
      id: "note-7",
      customerId: "3",
      content: "Customer experiencing temporary cash flow issues due to delayed project payments. Monitoring closely.",
      createdAt: "2024-01-13T15:45:00Z",
      createdBy: {
        id: "3",
        name: "Mike Wilson",
      },
    },
  ],
  "4": [
    {
      id: "note-8",
      customerId: "4",
      content: "New customer onboarding completed. Initial credit limit set at $50,000 pending first payment performance.",
      createdAt: "2024-01-11T09:00:00Z",
      createdBy: {
        id: "1",
        name: "John Smith",
      },
    },
  ],
  "5": [
    {
      id: "note-9",
      customerId: "5",
      content: "Customer disputed invoice INV-045. Investigation in progress. Temporary hold on collection activities.",
      createdAt: "2024-01-14T16:20:00Z",
      createdBy: {
        id: "2",
        name: "Sarah Johnson",
      },
    },
    {
      id: "note-10",
      customerId: "5",
      content: "Spoke with accounts payable manager. They confirmed receipt of all invoices and will process payments by month end.",
      createdAt: "2024-01-09T14:10:00Z",
      createdBy: {
        id: "2",
        name: "Sarah Johnson",
      },
    },
  ],
};

/**
 * Get notes for a specific customer
 */
export function getCustomerNotes(customerId: string): CustomerNote[] {
  return mockCustomerNotes[customerId] || [];
}

/**
 * Add a new note for a customer
 */
export function addCustomerNote(
  customerId: string,
  content: string,
  userId: string,
  userName: string
): CustomerNote {
  const newNote: CustomerNote = {
    id: `note-${Date.now()}`,
    customerId,
    content,
    createdAt: new Date().toISOString(),
    createdBy: {
      id: userId,
      name: userName,
    },
  };

  if (!mockCustomerNotes[customerId]) {
    mockCustomerNotes[customerId] = [];
  }

  // Add to the beginning of the array (newest first)
  mockCustomerNotes[customerId].unshift(newNote);

  return newNote;
}
